import ErrorIcon from "@mui/icons-material/Error";
import { routeConfigDynamic } from "routes/RouteConfig";
import {
  StringRegex,
  emailReg,
  gstNumberRegex,
  panCardRegex,
  serviceTaxRegex,
  ApprovTimeRegex,
  VpaRegex,
  amountRegex,
  accountNumberRegex,
  transectionRegex,
  chequeNumberRegex,
  ddNumberRegex,
  vehicleRegex,
} from "./Regex";
import moment from "moment/moment";

export const isAuthUsers = (path) => {
  let isAuth = false;

  let routeConfig = dynamicRoutingByModule(routeConfigDynamic);

  routeConfig?.forEach((route) => {
    if (route.path === path) {
      isAuth = route.isAuth;
    }
    return isAuth;
  });

  return isAuth;
};

export const errorFieldText = (props) => {
  return (
    <div className="errorMessage">
      <ErrorIcon />
      <span>{props}</span>
    </div>
  );
};
 export const validatePhoneNumber = (phoneValue, countryCode) => {
  // Check if country code is India (+91)
  const isIndiaCode = countryCode?.value === "+91" || countryCode === "+91" || countryCode === "IN +91";
  
  // Empty validation - return true if the field is empty (letting required validation handle this)
  if (!phoneValue || phoneValue.length === 0) {
    return { isValid: false, message: "Phone number is required." };
  }
  
  if (isIndiaCode) {
    // India validation - must be exactly 10 digits
    return { 
      isValid: phoneValue.length === 10,
      message: "Enter a valid 10-digit number."
    };
  } else {
    // Other countries - between 8 and 11 digits
    return { 
      isValid: phoneValue.length >= 8 && phoneValue.length <= 11,
      message: "Enter a valid number (8-11 digits)." 
    };
  }
};
export const handleValidationForm = (data, submitType, companyDomain,radioName, formValues, formName) => {
  let formIsValid = true;
  let errorVal = {};
  const emailRegex = emailReg;
  let keys = Object.keys(data);

  keys.forEach((type, idx) => {
    // Prevent empty spaces at the beginning of the input
    if (typeof data[type] === "string" && data[type].startsWith(" ")) {
      formIsValid = false;
      return (errorVal[type] = errorFieldText(
        "Cannot start with an empty space"
      ));
    }

    const checkEmailDomain = (email) => {
      const emailDomain = email.split('@')[1].toLowerCase(); // Convert email domain to lowercase
      return companyDomain.map(domain => domain.toLowerCase()).includes(emailDomain); // Convert each domain in companyDomain to lowercase
    };

    switch (type) {
      case "mobileOrEmail":
        //check input validation
        if (type === "mobileOrEmail" && data[type]?.length !== 10) {
          if (emailRegex.test(data[type])) {
            errorVal[type] = "";
          } else {
            formIsValid = false;
            errorVal[type] = errorFieldText("Email or Mobile is incorrect");
          }
        } else if (data[type]?.length === 10) {
          if (Number(data[type])) {
            errorVal[type] = "";
          } else {
            formIsValid = false;
            errorVal[type] = errorFieldText("Email or Mobile is incorrect");
          }
        } else {
          errorVal[type] = "";
        }
        break;
      case "vendorName":
        //check input validation
        if (type === "vendorName" && data[type]?.length < 1) {
          formIsValid = false;
          errorVal[type] = errorFieldText("This field is required");
        } else {
          errorVal[type] = "";
        }
        break;
      case "companyName":
        //check input validation
        if (type === "companyName" && data[type]?.length < 1) {
          formIsValid = false;
          errorVal[type] = errorFieldText("This field is required");
        } else {
          errorVal[type] = "";
        }
        break;
      case "financeName":
      case "adminName":
      case "employeeName":
      case "bankName":
        if (StringRegex.test(data[type])) {
          formIsValid = false;
          errorVal[type] = errorFieldText("This field should be only text");
        } else {
          errorVal[type] = "";
        }
        break;
      case "amount":
        //check input validation
        if (amountRegex.test(data[type])) {
          errorVal[type] = "";
        } else {
          formIsValid = false;
          errorVal[type] = errorFieldText("Amount is incorrect");
        }
        break;
      case 'accountNo':
        //check input validation
        if(radioName==='RTGS')
        {if (accountNumberRegex.test(data[type])) {
          errorVal[type] = "";
        } else {
          formIsValid = false;
          errorVal[type] = errorFieldText("Account number is incorrect");
        }}
        break;
      case "utrTransactionId":
        //check input validation
        if(radioName==='RTGS')
        {if (transectionRegex.test(data[type])) {
          errorVal[type] = "";
        } else {
          formIsValid = false;
          errorVal[type] = errorFieldText('Transaction number is incorrect');
        }}
        break;
      case "chequeNo":
        //check input validation
        if(radioName==='Cheque')
        {if (chequeNumberRegex.test(data[type])) {
          errorVal[type] = "";
        } else {
          formIsValid = false;
          errorVal[type] = errorFieldText("Cheque number is incorrect");
        }}
        break;
      case "demandNo":
        //check input validation
        if(radioName==='DemandDraft')
        {if (chequeNumberRegex.test(data[type])) {
          errorVal[type] = "";
        } else {
          formIsValid = false;
          errorVal[type] = errorFieldText("DD number is incorrect");
        }}
        break;
      case "phoneNumber":
      case "employeeMobilNumber":
      case "number":
        //check input validation
        // For guest users, phone number is optional
        if (formValues?.travellerDetails === 'guestUser' && !data[type]?.length) {
          formIsValid = true;
          errorVal[type] = '';
        }
        else if (formName ===  'companyOnbaording' && !data[type]?.length) {
          formIsValid = true;
          errorVal[type] = '';
        }
        else if (data[type] === "e") {
          data[type] = 0;
        }
     
        else if (data[type]?.length !== 10 && formName !== "reservation") {
          formIsValid = false;
          errorVal[type] = errorFieldText("Mobile number is incorrect");
          handleWindowScroll(0, submitType);
        } else if (data[type]?.length === 10 && formName !== "reservation") {
          if (Number(data[type])) {
          } else {
            formIsValid = false;
            errorVal[type] = errorFieldText("Mobile number is incorrect");
          }
        } else {
          errorVal[type] = "";
        }
        break;
      case "mobileNumber":
            if (data[type] === "e") {
              data[type] = 0;
            }
            if (data[type]?.length === 0) {
              formIsValid = true;
              errorVal[type] = '';
            }
            else if (data[type]?.length !== 10) {
              formIsValid = false;
              errorVal[type] = errorFieldText("Mobile number is incorrect");
              handleWindowScroll(0, submitType);
            } else if (data[type]?.length === 10) {
              if (Number(data[type])) {
              } else {
                formIsValid = false;
                errorVal[type] = errorFieldText("Mobile number is incorrect");
              }
            } else {
              errorVal[type] = "";
            }
            break;
      case "email":
      case "emailID":
        // For guest users, email is optional
        if (formValues?.travellerDetails === 'guestUser' && !data[type]?.length) {
          formIsValid = true;
          errorVal[type] = '';
        }
        else if (formName ===  'companyOnbaording' && !data[type]?.length) {
          formIsValid = true;
          errorVal[type] = '';
        }
        else if ((type === 'email' || type === 'emailID') && data[type]?.length && emailRegex.test(data[type])) {
          errorVal[type] = '';
        } else if ((type === 'email' || type === 'emailID') && !data[type]?.length) {
          // Email is empty - allow for guest users
          errorVal[type] = '';
        } else {
          formIsValid = false;
          errorVal[type] =  errorFieldText('Enter a valid email address');
        }
        break;
        case "adminEmail":
            if (
              (type === 'adminEmail') &&
              emailRegex.test(data[type]) && 
              checkEmailDomain(data[type])
            ) {
              errorVal[type] = '';
            } else {
              formIsValid = false;
              if(data[type]?.search("@") > 0) {
                errorVal[type] = errorFieldText("Enter a valid domain");
              }
              else {
                errorVal[type] = errorFieldText("Enter a valid email ID");
              }
            }
        break;
        case "financeEmail":
          if (data[type]?.length === 0) {
            formIsValid = true;
            errorVal[type] = '';
          }
           else if (
               emailRegex.test(data[type]) && 
              checkEmailDomain(data[type])
            ) {
              errorVal[type] = '';
            } else {
              formIsValid = false;
              if(data[type]?.search("@") > 0) {
                errorVal[type] = errorFieldText("Enter a valid domain");
              }
              else {
                errorVal[type] = errorFieldText("Enter a valid email ID");
              }
            }
        break;

      case "newEmployee":
              //check input validation for new employee
              if(formValues?.travellerDetails === "new user") {
                if (
                  (type === "newEmployee") &&
                  emailRegex.test(data[type]) && 
                  checkEmailDomain(data[type])
               ) {
                 errorVal[type] = "";
               } else {
                formIsValid = false;
                if(data[type]?.search("@") > 0) {
                  errorVal[type] = errorFieldText("Enter a valid domain");
                }
                else {
                  errorVal[type] = errorFieldText("Enter a valid email ID");
                }
              }
              }
              break;
      case "pinCode":
        //check picode validation
        if (data[type]?.length === 6) {
          errorVal[type] = "";
        } else {
          formIsValid = false;
          errorVal['pinCode'] = errorFieldText('Enter a valid Pincode');
        }
        break;
      case "vpa":
        //check picode validation
        if (data[type]?.length && VpaRegex.test(data[type])) {
          errorVal[type] = "";
        } else {
          formIsValid = false;
          errorVal[type] = errorFieldText("Enter a valid VPA");
          handleWindowScroll(0, submitType);
        }
        break;
      case "panNumber":
        //check input validation
        if (data[type]?.length === 10 && panCardRegex.test(data[type])) {
          errorVal[type] = "";
        } else {
          formIsValid = false;
          errorVal[type] = errorFieldText("Enter a valid PanNumber");
          handleWindowScroll(0, submitType);
        }
        break;
      case "approvalDuration":
        //check input validation
        if (data[type] === null || data[type] === 0) {
          errorVal[type] = "";
        } else if (ApprovTimeRegex.test(data[type])) {
          errorVal[type] = "";
        } else {
          errorVal[type] = errorFieldText("Value should be between 1-48");
        }
        break;
        case "noOfTravelers": {
          const seater = Number(formValues?.vehicleSeater);
        if(seater === 0 || Number(data[type]) > seater) {
          formIsValid = false;
          errorVal[type] = `Max no. of passengers allowed is ${seater}`;
        }
        else {
          formIsValid = true;
          errorVal[type] = "";
        }
        break;
      }
      case "regNumber": {
        if ( vehicleRegex.test(data[type])) {
          errorVal[type] = "";
        } else {
          formIsValid = false;
          errorVal[type] = errorFieldText("Enter a valid Vehicle Number");
        }
      break;
    }
      case "serviceTaxNumber":
        //check input validation
        if (data[type]?.length === 15 && serviceTaxRegex.test(data[type])) {
          errorVal[type] = "";
        } else {
          formIsValid = false;
          errorVal[type] = errorFieldText("Enter a valid Service Tax Number");
        }
        break;
      default:
    }

    // Check if required is false and length is 0
    if (!data[type] && data[type]?.length === 0) {
      errorVal[type] = "";
    }
  });

  return { formIsValid, errorVal };
};

export const getCurrentUser = () => {
  let user = null;
  try {
    user =
      localStorage.getItem("token") != null
        ? localStorage.getItem("token")
        : null;
  } catch (error) {
    user = null;
  }
  return user;
};

export const setCurrentUser = (user) => {
  try {
    if (user) {
      return user.data;
    } else {
      return user;
    }
  } catch (error) {
    return error;
  }
};

  export const setCustomerComplaint = (complaint) => {
    try {
      if (complaint) {
        return complaint.data;
      } else {
        return complaint;
      }
    } catch (error) {
      return error;
    }
  };

export const truncateComment = (comment, wordLimit) => {
  if (comment?.length > wordLimit) {
    return comment.slice(0, wordLimit) + "...";
  } else {
    return comment;
  }
};

export const getReservationDetailsObject = (reservationData) => {
  if (reservationData?.AirportTrip) {
    return reservationData?.AirportTrip;
  } else if (reservationData?.B2bRentalTrip) {
    return reservationData?.B2bRentalTrip;
  } else if (reservationData?.OutStationTrip) {
    return reservationData?.OutStationTrip;
  } else if (reservationData?.OutStationTripOneWay) {
    return reservationData?.OutStationTripOneWay;
  } else {
    return {};
  }
};

export const optionsList = (listData, data) => {
  switch (data) {
    case "dutyTypeOption":
    case "cityOption":
    case "parentCompanyList":
      return listData?.map((val, idx) => {
        return { value: val?.id, label: val?.name };
      });
    case "carOption":
      return listData?.body?.map((val, idx) => {
        return { value: val?.id, label: val?.carType };
      });
    default:
      return [{}];
  }
};

export const getDateFormat = (value, type) => {
  switch (type) {
    case "fromNowFormat":
      return moment(value).fromNow();
    case "timeFormat":
      return moment(value, "DD/MM/YYYY hh:mm a").toISOString();
    case "moreDetails":
      return moment(value).format("DD MMMM YYYY");
    case "reservationDateFormat":
      return moment(value).format("MM/DD/YYYY");
    case "onboardingDateFormat":
      return moment(value).format("YYYY-MM-DD");
    case "tenureDateFormat":
      return moment(value).format("MM-DD-YYYY");
    case "weekDay":
      return moment(value).format("ddd DD MMM, YYYY");
    default:
      return moment(value).format("DD/MM/YYYY");
  }
};

export const getTimeFormat = (data) => {
  if (data) {
    return moment(data).format("HH:mm");
  }
};

export const getDateComparision = (value) => {
  const currentDateObj = new Date();
  const currentYear = currentDateObj.getFullYear();
  const currentMonth = currentDateObj.getMonth() + 1; // Adding 1 as months are zero-based
  const currentDate = currentDateObj.getDate();

  const providedDateObj = new Date(value);

  const providedYear = providedDateObj.getFullYear();
  const providedMonth = providedDateObj.getMonth() + 1; // Adding 1 as months are zero-based
  const providedDate = providedDateObj.getDate();

  //Comparing date based on year
  if (providedYear > currentYear) {
    return true;
  } else if (providedYear === currentYear) {
    //Comparing date based on month
    if (providedMonth > currentMonth) {
      return true;
    } else if (providedMonth === currentMonth) {
      //Comparing date based on day
      if (providedDate > currentDate) {
        return true;
      }
    }
  }
};

export const isValidTripTime = (value) => {
  const currentTime = new Date();
  const tripTime = new Date(value);

  // Calculate the difference in milliseconds
  const diffMs = tripTime.getTime() - currentTime.getTime();

  // Convert ms → hours
  const diffHours = diffMs / (1000 * 60 * 60);

  // Check if the trip time is at least 1 hour ahead
  return diffHours >= 1;
};


//function to window scroll by script
export const handleWindowScroll = (scrollValue, submitType) => {
  if (submitType) {
    const element = document.getElementsByClassName("formDiv");
    element[0].scroll({
      top: scrollValue,
      behavior: "smooth",
    });
  }
};

// Function to fix the digit after decimal
export const formatNumber = (value) => {
  if (typeof value === "number" && !isNaN(value)) {
    return value.toFixed(2);
  }
  return !isNaN(value) ? Number(value).toFixed(2) : 0;
};

//Currency formatter
export const formatCurrency = (amount) => {
  if (!isNaN(amount)) {
    const tempAmount = formatNumber(amount);
    return new Intl.NumberFormat("en-IN").format(tempAmount);
  }
  return amount || "0";
};

// CGST calculation
export const calculateAmount = (baseAmount, percentage) =>
  (baseAmount * percentage) / 100;

// Abbreviate Number
export const abbreviateNumber = (value) => {
  if (value > 999 && value < 100000) {
    return Number(value / 1000).toFixed(2) + "K";
  }

  //Formatting to Lakhs
  else if (value >= 100000 && value <= 10000000) {
    return Number((value / 100000).toFixed(2)) + "L";
  }

  //Formatting to crores
  else if (value >= 10000000) {
    return Number((value / 10000000).toFixed(2)) + "cr";
  }

   else if (value < 900) {
    return Number(value).toFixed(2);
  }

  return value;
};

//calculating week days
export const calcLabels = (value) => {
  //for calculating the labels in year terms
  if (value > 1372) {
    return 365; //days per year
  }  
  //for calculating the labels in months terms
  else if (value > 98) {
    return 30; //days per month
  }
  //for calculating the labels in week terms
   else if (value > 14) {
    return 7; //days per week
  } else {
    return value;
  }
};

export const formatingChart = (rideAnalytic) => {
  let tempResponse = rideAnalytic;
  const labelsLength = Number(calcLabels(tempResponse?.labels?.length));

  let labels =
    tempResponse?.labels?.length < 14
      ? tempResponse?.labels
      : tempResponse?.labels?.filter((_, i) => i % labelsLength === 0);
  tempResponse["labels"] = labels;

  for (let i = 0; i < tempResponse?.datasets?.length; i++) {
    tempResponse["datasets"][i].data =
      tempResponse?.labels?.length < 14
        ? tempResponse?.datasets?.[i]?.data
        : tempResponse?.datasets?.[i]?.data?.filter(
            (_, i) => i % labelsLength === 0
          );
  }

  return tempResponse;
};
export const isNumeric = (value)  => {
  return (
    /^[0-9.]*$/.test(value) && !value.includes("e") && !value.includes("-")
  );
}

export const reservationHeader = (key) => {
  switch (key) {
    case "bookingCompany" :
      return "Booking receive from"
      case "travellerDetails" :
      return "Enter Traveller Details"
      case "dutyAndVehicle" :
      return "Select Duty Type & Vehicle Category Details"
      case "tripDetails" :
      return "Enter Trip Details"
      case "tripNote" :
      return "Add any Special Instruction"
      case "billingType" :
      return "Billing Details"
      default :
      return key
  }
}

//Dynamic routing filtering
export  const dynamicRoutingByModule = (arr1) => {

  const dynamicRouting = localStorage.getItem("rolesPermissions")?.length > 0 && JSON.parse(localStorage.getItem("rolesPermissions"));

  let res = [];
  res = arr1?.filter(el => {
     return dynamicRouting?.length && dynamicRouting?.find(element => {
        return element?.toLowerCase() === el?.moduleKey?.toLowerCase();
     });
  });
  return res;
}


export const handlePermissions = (permissionArray, module, accessKey) => {
  const findPermissions = (modules) => {
    if (!modules || !Array.isArray(modules)) return false;

    for (let i = 0; i < modules.length; i++) {
      const moduleItem = modules[i];
      const permissionsAccess = moduleItem.Permissions?.map(perm => perm.permissionName);
      
      if (permissionsAccess?.includes(accessKey.customAccess)) return true;
      if (permissionsAccess?.includes(accessKey.defaultAllAccess)) return true;

      if (moduleItem.subModule && moduleItem.subModule.length > 0) {
        const subModulePermission = findPermissions(moduleItem.subModule);
        if (subModulePermission) return true;
      }
    }

    return false;
  };

  const moduleItem = permissionArray?.find(arr => arr.moduleKey === module);
  if (!moduleItem) return false;

  const permissionsAccess = moduleItem.Permissions?.map(perm => perm.permissionName);

  if (permissionsAccess?.includes(accessKey.customAccess)) return true;
  if (permissionsAccess?.includes(accessKey.defaultAllAccess)) return true;

  return findPermissions(moduleItem.subModule);
};

export const  convertDecimalHoursToTime =(decimalHours) => {
  let hours = Math.floor(decimalHours);
  let minutes = Math.round((decimalHours - hours) * 60);
  return `${hours} hr ${minutes} mins`;
}

  export const dateFormate = (date, dFormate) => {
    if(dFormate ==='toIsoString'){
      const formedDate = moment(date).toISOString();

      if(formedDate == 'Invalid date') {
        return date || '';
      }

      return formedDate
    } else if(date !== null && date !== undefined && date !== "" && date !== "Invalid date"){
      // Check if date is already in DD/MM/YYYY format
        const ddMmYyyyRegex = /^\d{2}\/\d{2}\/\d{4}$/;
        
        if(ddMmYyyyRegex.test(date)) {
          // Already in DD/MM/YYYY format, return as-is
          return date;
        }
        const formedDate = moment(date).local().format(dFormate)
        if(formedDate == 'Invalid date') {
          return date || '';
        }

        return formedDate
      } else{
        return ""
      }
  };

  export const validateFieldOnChange = (fieldConfig, value) => {
  const { required, validation, label, name } = fieldConfig;

  if (required && (!value || value.trim().length === 0)) {
    return {
      isValid: false,
      error: `${label || name} is required`
    };
  }

  if (validation?.pattern?.value instanceof RegExp) {
    if (!validation.pattern.value.test(value)) {
      return {
        isValid: false,
        error: `${validation.pattern.message || "Invalid format"}`,
      };
    }
  }

  return { isValid: true, error: "" };
};